export default import.meta.ROLLUP_FILE_URL_DJR5p6tE05Gjb9yHCzeI3A